import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=cb3fe7f4&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3fe7f4')) {
      api.createRecord('cb3fe7f4', component.options)
    } else {
      api.reload('cb3fe7f4', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=cb3fe7f4&", function () {
      api.rerender('cb3fe7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/icon/src/icon.vue"
export default component.exports